import { useEffect, useState } from "react";
import { Trophy } from "lucide-react";
import { api } from "@/lib/api";

export default function OrganizationScore() {
  const [score, setScore] = useState(null);

  useEffect(() => {
    api.get("/family/score").then(({ data }) => setScore(data)).catch(() => {});
  }, []);

  if (!score) return null;

  // Circular progress
  const circumference = 2 * Math.PI * 36;
  const offset = circumference - (score.score / 100) * circumference;

  return (
    <div data-testid="organization-score" className="bg-surface border border-subtle rounded-3xl p-5 mb-5 animate-fade-up">
      <div className="flex items-center gap-4">
        {/* Circular SVG progress */}
        <div className="relative shrink-0">
          <svg width="84" height="84" viewBox="0 0 84 84" className="-rotate-90">
            <circle cx="42" cy="42" r="36" stroke="var(--bg-elevated)" strokeWidth="6" fill="none" />
            <circle
              cx="42" cy="42" r="36" stroke="var(--brand)" strokeWidth="6" fill="none"
              strokeDasharray={circumference}
              strokeDashoffset={offset}
              strokeLinecap="round"
              style={{ transition: "stroke-dashoffset 1s ease-out" }}
            />
          </svg>
          <div className="absolute inset-0 grid place-items-center">
            <div className="text-center">
              <div className="font-display text-2xl font-semibold leading-none">{score.score}</div>
              <div className="text-[10px] text-tertiary-fg uppercase tracking-widest mt-0.5">/100</div>
            </div>
          </div>
        </div>

        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2">
            <Trophy className="w-4 h-4 text-amber-warm" />
            <span className="text-xs uppercase tracking-widest text-tertiary-fg font-semibold">Punteggio Organizzazione</span>
          </div>
          <div className="font-display text-lg font-medium mt-1.5 flex items-center gap-2">
            <span className="text-2xl">{score.emoji}</span> {score.label}
          </div>
          <p className="text-xs text-secondary-fg mt-1 leading-snug">{score.message}</p>
        </div>
      </div>
    </div>
  );
}
